import { useState, useEffect } from 'react'
import { X, FileText } from 'lucide-react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { pageApi } from '@/api'
import { sanitizeHtml } from '@/lib/utils'

interface AgreementDialogProps {
  slug: string
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function AgreementDialog({ slug, open, onOpenChange }: AgreementDialogProps) {
  const [content, setContent] = useState<{ title: string; content: string } | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (!open) {
      setContent(null)
      return
    }
    setLoading(true)
    pageApi.getBySlug(slug)
      .then((res: any) => setContent(res || null))
      .catch(() => setContent(null))
      .finally(() => setLoading(false))
  }, [slug, open])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh] overflow-hidden flex flex-col">
        <DialogHeader className="border-b border-[#E5E7EB] pb-4">
          <DialogTitle className="flex items-center gap-2 text-text-primary">
            <FileText className="w-5 h-5 text-[#3662EC]" />
            {content?.title || '协议内容'}
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto py-4">
          {loading ? (
            <div className="flex items-center justify-center py-12 text-text-secondary text-sm">
              加载中...
            </div>
          ) : content?.content ? (
            <div
              className="prose prose-sm max-w-none prose-headings:text-text-primary prose-p:text-text-body prose-a:text-[#3662EC] prose-li:text-text-body"
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(content.content) }}
            />
          ) : (
            <div className="flex items-center justify-center py-12 text-text-placeholder text-sm">
              暂无内容
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  )
}
